// Data sevice
import axios from "axios";
import authHeader from "./auth-header";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
const API_URL = process.env.VUE_APP_API_URL;

class TransactionsService {

    
  index(params = {}) {
    return axios.get(API_URL + "transactions", {
      headers: authHeader(),
      params,
    });
  }

  show(id) {
    return axios.get(API_URL + "transactions/" + id, { headers: authHeader() });
  }
  store(resource) {
    return axios.post(API_URL + "transactions", resource, {
      headers: authHeader(),
    });
  }
  update(resource) {
    return axios.put(API_URL + "transactions/" + resource.id, resource, {
      headers: authHeader(),
    });
  }
  delete(resource) {
    return axios.delete(API_URL + "transactions/" + resource.id, {
      headers: authHeader(),
    });
  }
}

export default new TransactionsService();
